module.exports = __webpack_public_path__ + "media/images/sp/articles/popular_contents_guide-98a6e880ad34040d8b9ae1fe2b4c3fb6.webp";